/**
 * Toast-уведомление (D5b, design round 2: Card-Toast-Modal mapping).
 *
 * Generic UI без знания домена — поэтому в shared/ui. Управляется
 * состоянием страницы (один toast за раз, без глобальной очереди —
 * добавим, когда появится второй потребитель).
 */
export interface ToastProps {
  message: string;
  /** error → role=alert + красный фон; info → role=status. */
  tone?: 'info' | 'error';
  /** Кнопка действия внутри toast'а (например «Повторить»). */
  actionLabel?: string;
  onAction?: () => void;
  onClose?: () => void;
}

export function Toast({
  message,
  tone = 'info',
  actionLabel,
  onAction,
  onClose,
}: ToastProps): JSX.Element {
  return (
    <div
      className={tone === 'error' ? 'ta-toast ta-toast--error' : 'ta-toast'}
      role={tone === 'error' ? 'alert' : 'status'}
      data-testid="toast"
    >
      <span className="ta-toast__msg">{message}</span>
      {actionLabel !== undefined && onAction !== undefined && (
        <button type="button" className="ta-toast__action" onClick={onAction}>
          {actionLabel}
        </button>
      )}
      {onClose !== undefined && (
        <button type="button" className="ta-toast__close" aria-label="Закрыть" onClick={onClose}>
          ✕
        </button>
      )}
    </div>
  );
}
